<template>
    <daq-cropperUploader :limit="2" @getPicList="getPicList"></daq-cropperUploader>
</template>

<script>
    export default {
        name: 'cropperUploader',
        methods: {
          /**
           * 获取图表列表
           * @param data
           */
          getPicList (data) {
            console.log(data)
          }
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/page/cropperUploader.vue